import { useTranslation } from 'react-i18next';

import AiChatDatasourceGrid from './AiChatDatasourceGrid';

import type { ReactElement } from 'react';
import type IAiChatDatasourceTable from '../interfaces/IAiChatDatasourceTable';

import styles from '../sass/AiChat.module.scss';

/** A stored result as a table: its title and count over the paged grid, and a note when it was cut. */
function AiChatDatasourceTable({
  datasourceId, title, columns, rowCount, truncated,
}: IAiChatDatasourceTable): ReactElement {
  const { t } = useTranslation();

  return (
    <div className={styles.datasource}>
      <div className={styles.toolHeader}>
        <p className={styles.datasourceTitle}>{title}</p>
        <p className={styles.toolStatus}>{t('aiChat.tools.datasourceRows', { count: rowCount })}</p>
      </div>

      {truncated ? (
        <p className={styles.note}>{t('aiChat.tools.datasourceTruncated', { count: rowCount })}</p>
      ) : null}

      <AiChatDatasourceGrid datasourceId={datasourceId} columns={columns} rowCount={rowCount} />
    </div>
  );
}

export default AiChatDatasourceTable;
